import React, { useEffect, useState } from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { Plug } from '@plone/volto/components/manage/Pluggable';
import { Button } from 'react-aria-components';
import { useDispatch, useSelector } from 'react-redux';
import { invalidatePage, invalidatePageReset } from 'rer-theme/actions';
import { Toast } from '@plone/volto/components';
import { injectLazyLibs } from '@plone/volto/helpers/Loadable/Loadable';
import { flattenToAppURL } from '@plone/volto/helpers';

const messages = defineMessages({
  invalidate_page_success: {
    id: 'invalidate_page_success',
    defaultMessage: 'Page invalidated.',
  },
  invalidate_page_error: {
    id: 'invalidate_page_error',
    defaultMessage: 'There was an error invalidating current page: ',
  },
  invalidate_page_generic_msg: {
    id: 'invalidate_page_generic_msg',
    defaultMessage: 'please contact site administrator.',
  },
});

export const InvalidatePageAction = ({ toastify }) => {
  const [purgeAction, setPurgeAction] = useState(null);

  const intl = useIntl();
  const dispatch = useDispatch();
  const actions = useSelector((state) => {
    return state?.content?.data?.['@components']?.actions?.object_buttons;
  });

  const invalidatePageState = useSelector((state) => state.invalidatePage);

  useEffect(() => {
    setPurgeAction(
      actions
        ? actions.filter((action) => action.id === 'purge-content')[0]
        : null,
    );
  }, [actions]);

  useEffect(() => {
    if (!invalidatePageState.loading && invalidatePageState.loaded) {
      if (invalidatePageState.error) {
        const msg =
          invalidatePageState.error?.response?.body?.message ||
          intl.formatMessage(messages.invalidate_page_generic_msg);
        const errorMsg = `${intl.formatMessage(
          messages.invalidate_page_error,
        )} ${msg}`;
        toastify.toast.error(<Toast error content={errorMsg} />);
      } else if (invalidatePageState.success) {
        toastify.toast.success(
          <Toast
            success
            content={intl.formatMessage(messages.invalidate_page_success)}
          />,
        );
      }
      dispatch(invalidatePageReset());
    }
  }, [invalidatePageState]);

  if (!purgeAction) {
    return '';
  }

  const callPurge = () => {
    dispatch(invalidatePage(flattenToAppURL(purgeAction.url)));
  };
  const actionTitle = purgeAction.title || purgeAction.id;
  return (
    <Plug
      pluggable="toolbar-more-menu-list"
      id="invalidate-page-action"
      dependencies={[purgeAction]}
    >
      <li className="invalidate-page">
        <Button
          className="invalidate-page-button"
          onClick={() => {
            dispatch(invalidatePage(flattenToAppURL(purgeAction.url)));
          }}
          title={actionTitle}
        >
          {actionTitle}
        </Button>
      </li>
    </Plug>
  );
};

export default injectLazyLibs(['toastify'])(InvalidatePageAction);
